module.exports = __webpack_public_path__ + "static/media/josephl.757da772.jpg";